import React from "react";
import { useSelector } from "react-redux";
import DomoFunnel from "../../../../../components/domoFunnel/domoFunnel";

function FunnelChart() {
  const offersDataNormalized = useSelector(
    (state) => state.challengerConversion.offersDataNormalized
  );

  return <DomoFunnel label="Challengers" chartWidth={880} dataArray={offersDataNormalized} />;
}

export default FunnelChart;
